import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { FiMinus, FiPlus, FiTrash2 } from "react-icons/fi";
import { formatMoney, getOrderTotals } from "../utils/commerce";
import ProductCard from "./ProductCard";

function CartPage() {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const { lines, subtotal, shipping, total } = getOrderTotals(cartItems, productData);

  if (lines.length === 0) {
    return (
      <main className="cart-page cart-page--empty">
        <section className="empty-cart">
          <p className="eyebrow">Your bag</p>
          <h1>Your cart is empty</h1>
          <p>Ready to find your new favourite denim?</p>
          <Link to="/shop" className="button button--dark">Continue shopping</Link>
        </section>
        <section className="cart-recommendations page-section">
          <div className="section-heading"><h2>New to the collection</h2><Link to="/shop">Shop all</Link></div>
          <div className="cart-recommendations__grid">{productData.slice(0, 4).map((product) => <ProductCard key={product.id} product={product} />)}</div>
        </section>
      </main>
    );
  }

  return (
    <main className="cart-page">
      <header className="cart-heading"><p className="eyebrow">Your bag</p><h1>Shopping Cart</h1><span>{lines.reduce((sum, line) => sum + line.quantity, 0)} items</span></header>
      <div className="cart-layout">
        <section className="cart-lines" aria-label="Cart items">
          <div className="cart-lines__head"><span>Product</span><span>Quantity</span><span>Subtotal</span></div>
          {lines.map(({ product, quantity, size, color, lineTotal }) => (
            <article className="cart-line" key={`${product.id}-${size}-${color}`}>
              <Link className="cart-line__image" to={`/products/${product.id}`}><img src={product.image} alt={product.name} /></Link>
              <div className="cart-line__info">
                <Link to={`/products/${product.id}`}>{product.name}</Link>
                <span>{color} / {size}</span>
                <span>{formatMoney(product.price)}</span>
                <button type="button" className="cart-line__remove-mobile" onClick={() => removeFromCart(product.id, size, color)}><FiTrash2 /> Remove</button>
              </div>
              <div className="cart-quantity">
                <button type="button" aria-label={`Decrease ${product.name} quantity`} onClick={() => updateQuantity(product.id, size, color, quantity - 1)} disabled={quantity <= 1}><FiMinus /></button>
                <span>{quantity}</span>
                <button type="button" aria-label={`Increase ${product.name} quantity`} onClick={() => updateQuantity(product.id, size, color, quantity + 1)} disabled={quantity >= 10}><FiPlus /></button>
              </div>
              <strong className="cart-line__total">{formatMoney(lineTotal)}</strong>
              <button type="button" className="cart-line__remove" aria-label={`Remove ${product.name}`} onClick={() => removeFromCart(product.id, size, color)}><FiTrash2 /></button>
            </article>
          ))}
          <div className="cart-lines__foot">
            <Link to="/shop">← Continue shopping</Link>
            <button type="button" onClick={() => setNoteOpen((value) => !value)}>Add order note {noteOpen ? "−" : "+"}</button>
          </div>
          {noteOpen && <div className="order-note"><label htmlFor="order-note">Order note</label><textarea id="order-note" placeholder="Add a note for our dispatch team" /></div>}
        </section>

        <aside className="cart-summary">
          <div className="shipping-meter">
            <p><strong>Standard shipping is {formatMoney(9.99)} per order.</strong></p>
          </div>
          <h2>Order summary</h2>
          <dl>
            <div><dt>Subtotal</dt><dd>{formatMoney(subtotal)}</dd></div>
            <div><dt>Shipping</dt><dd>{shipping === 0 ? "Free" : formatMoney(shipping)}</dd></div>
            <div className="cart-summary__total"><dt>Total <small>USD</small></dt><dd>{formatMoney(total)}</dd></div>
          </dl>
          <p className="cart-summary__tax">Taxes and the fixed shipping charge are included in the total shown.</p>
          <label className="terms-check"><input type="checkbox" checked={termsAccepted} onChange={(event) => setTermsAccepted(event.target.checked)} />I agree to the <Link to="/terms">terms</Link>.</label>
          <button className="button button--dark cart-checkout" type="button" disabled={!termsAccepted} onClick={() => navigate("/checkout")}>Checkout — {formatMoney(total)}</button>
          {!termsAccepted && <small className="checkout-hint">Accept the terms to continue.</small>}
        </aside>
      </div>
    </main>
  );
}

export default CartPage;
